import { PATHS } from "@/internals/constants/paths";
import { DomainRouteConfig } from "../types";

const publicRoutes = [
  PATHS.LOGIN,
  PATHS.SIGNUP,
  PATHS.FORGOT_PASSWORD,
  PATHS.RESET_PASSWORD,
  PATHS.TERMS_AND_CONDITIONS,
  PATHS.TERMS_OF_USE,
  PATHS.PRIVACY_POLICY,
  PATHS.COOKIES_POLICY,
  "/about-us",
  PATHS.CONTACT_US,
  "/how-we-are",
  PATHS.PRICING,
  PATHS.FAQ,
  PATHS.VERIFY_PAYMENT,
  PATHS.INACTIVE,
];

const initialPrefetchRoutes = [PATHS.HOME, PATHS.LOGIN, PATHS.SIGNUP, PATHS.PRICING, PATHS.PAYMENT];

export const defaultConfig: DomainRouteConfig = {
  requiresAuth: false,
  homePath: "/",
  logoLinkEnabled: true,
  authRedirectPath: "/",
  logoutRedirectPath: "/",
  publicRoutes,
  initialPrefetchRoutes,
  abTestConfig: {
    provider: "vwo",
    enabled: false,
    config: {},
  },
};

export const domainConfigs: Record<string, DomainRouteConfig> = {
  localhost: defaultConfig,
  "fastqrgenerator.com": defaultConfig,
  "app.qrnow.com": {
    requiresAuth: true,
    homePath: "/my-qr-codes",
    logoLinkEnabled: false,
    authRedirectPath: "/login",
    logoutRedirectPath: "/login",
    publicRoutes,
    initialPrefetchRoutes,
  },
  "app.onlineqrcode.com": {
    requiresAuth: true,
    homePath: "/qr-editor",
    logoLinkEnabled: true,
    authRedirectPath: "/qr-editor",
    logoutRedirectPath: "/qr-editor",
    publicRoutes: [...publicRoutes, "/qr-editor"],
    initialPrefetchRoutes,
  },
  "qrcreator.com": {
    ...defaultConfig,
    initialPrefetchRoutes: [],
    abTestConfig: {
      provider: "vwo",
      enabled: true,
      config: {
        accountId: "116448",
      },
    },
    amplitudeWebExperimentsEnabled: true,
  },
};

export const getDomainConfig = (hostname: string): DomainRouteConfig => {
  const foundConfig = Object.entries(domainConfigs).find(([domain]) =>
    hostname.includes(domain)
  )?.[1];

  return foundConfig ?? defaultConfig;
};
